import React, { useRef, useEffect, ReactNode } from "react";
import { Fancybox as NativeFancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

interface FancyboxProps {
  className?: string;
  delegate?: string;
  options?: Record<string, any>;
  children: ReactNode;
}

const Fancybox: React.FC<FancyboxProps> = ({
  className,
  delegate = "[data-fancybox]",
  options = {},
  children,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const container = containerRef.current;

    if (container) {
      NativeFancybox.bind(container, delegate, options);

      return () => {
        NativeFancybox.unbind(container);
        NativeFancybox.close();
      };
    }
  }, [delegate, options]);

  return (
    <div className={className} ref={containerRef}>
      {children}
    </div>
  );
};

export default Fancybox;
